class Constants {
    static readonly BYTE_OFFSET_FLOAT: number = 4;
    static readonly BYTE_OFFSET_DOUBLE: number = 8;

    static readonly BYTE_OFFSET_INT: number = 4;
}

export { Constants }